module.exports = __webpack_public_path__ + "static/6-88cf9ec14284638a1205f37c0e7a76e0.jpg";